export const BRAND_CONTEXT_CATEGORIES = [
  "Brand Voice",
  "Customer Insights",
  "Competitive Intel",
  "Product Knowledge",
  "Campaign Learnings",
  // AUT-430: dismissed and removed strategies are written here (formerly "SEO Strategy").
  "Strategy",
  "Other",
] as const;

export type BrandContextCategory = (typeof BRAND_CONTEXT_CATEGORIES)[number];

export type BrandLearning = {
  id: string;
  title: string;
  body: string;
  category: string;
  tags: string[];
  authorName: string;
  createdAt: string;
};

export type BrandContextDocumentExtractionStatus = "pending" | "processing" | "done" | "failed";

export type BrandContextDocument = {
  id: string;
  title: string;
  category: string;
  tags: string[];
  fileName: string;
  fileSize: number;
  mimeType: string;
  extractionStatus: BrandContextDocumentExtractionStatus;
  authorName: string;
  createdAt: string;
};
